import { createRoute } from '@tanstack/react-router';
import { lazyPage } from '../common';
import { siteRoute } from '../layouts';

const pages = () => import('./oauth-pages');
const brightpearlComp = lazyPage(pages, 'BrightpearlOAuthCallbackHost');
const katanaComp = lazyPage(pages, 'KatanaOAuthCallbackHost');
const quickbooksComp = lazyPage(pages, 'QuickBooksOAuthCallbackHost');
const xeroComp = lazyPage(pages, 'XeroOAuthCallbackHost');

const brightpearlOAuthRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'integrations/partners/oauth/brightpearl',
  component: brightpearlComp,
  staticData: { title: 'integrations.oauth_brightpearl' },
});

const katanaOAuthRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'integrations/partners/oauth/katana',
  component: katanaComp,
  staticData: { title: 'integrations.oauth_katana' },
});

const quickbooksOAuthRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'integrations/partners/oauth/quickbooks',
  component: quickbooksComp,
  staticData: { title: 'integrations.oauth_quickbooks' },
});

const xeroOAuthRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'integrations/partners/oauth/xero',
  component: xeroComp,
  staticData: { title: 'integrations.oauth_xero' },
});

/** OAuth callback sub-group of the integrations family. */
export const oauthLeaves = [
  brightpearlOAuthRoute,
  katanaOAuthRoute,
  quickbooksOAuthRoute,
  xeroOAuthRoute,
];
